import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface ReleaseNotesData {
  version: string;
  date: string;
  features: string[];
  bugFixes: string[];
}

@Injectable({
  providedIn: 'root'
})
export class ReleaseNotesService {
  private readonly jsonUrl = 'assets/data/release-notes.json';
  private readonly STORAGE_KEY = 'last_seen_version';

  constructor(private http: HttpClient) {}

  getLatestReleaseNotes(): Observable<ReleaseNotesData> {
    return this.http.get<ReleaseNotesData[]>(this.jsonUrl).pipe(
      map(releases => releases[0])
    );
  }

  shouldShowReleaseNotes(currentVersion: string): boolean {
    if (!currentVersion) {
      return false;
    }
    const lastSeenVersion = localStorage.getItem(this.STORAGE_KEY);
    return String(lastSeenVersion).trim() !== String(currentVersion).trim();
  }

  markVersionAsSeen(version: string): void {
    if (version) {
      localStorage.setItem(this.STORAGE_KEY, String(version).trim());
    }
  }
}